import { createAction, props } from '@ngrx/store';

import { AnalysesParams, Analysis } from '../analyses.interface';
import { BackendResponse } from 'src/app/core/interfaces/shared.interface';

export const setAnalyses = createAction(
  '[Analyses Component] Set Analyses',
  props<{ analyses: BackendResponse<Analysis>; params: AnalysesParams; pageNumber: number }>()
);

export const updateAnalysis = createAction('[Analyses Component] Update Analysis', props<{ analysis: Analysis }>());

export const toggleAnalysisStatus = createAction('[Analyses Component] Toggle Analysis status', props<{ analysisId: string }>());

export const updateManyAnalyses = createAction(
  '[Analyses Component] Update Many Analyses',
  props<{ analyses: { ids: string[]; changes: Partial<Analysis> } }>()
);

export const switchSelection = createAction('[Analyses Component] Switch Selection', props<{ id: string }>());

export const switchAllSelection = createAction('[Analyses Component] Switch All Selection', props<{ checked: boolean }>());

// Request

export const loadAnalyses = createAction('[Request/Api Analyses] Load Analyses', (params: AnalysesParams, pageNumber: number = 1) => ({
  params,
  pageNumber
}));

export const changeAnalysisStatus = createAction('[Request/Api Analyses] Change Analysis Status', props<{ id: string }>());

export const changeManyAnalysesStatus = createAction(
  '[Request/Api Analyses] Change Many Analyses Status',
  props<{ payload: { ids: string[]; muted: string } }>()
);
